import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

const Alerts = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    fetch('/api/filtered/alerts')
      .then((res) => res.json())
      .then((data) => setAlerts(data))
      .catch((err) => console.error("Failed to load alerts", err));
  }, []);

  const formatToCST = (isoString) => {
    const localTime = new Date(isoString).toLocaleString("en-US", {
      timeZone: "America/Chicago",
    });
    return localTime;
  };

  return (
    <div style={{ display: "flex", background: "#eee", minHeight: "100vh" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "2rem" }}>
        <h2>⚠️ Alerts</h2>
        <div style={{ background: "#fff", padding: "1rem", borderRadius: "10px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#ddd" }}>
                <th style={thStyle}>Device ID</th>
                <th style={thStyle}>Type</th>
                <th style={thStyle}>Detail</th>
                <th style={thStyle}>Timestamp (CST)</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((alert, index) => (
                <tr key={index} style={{ textAlign: "center" }}>
                  <td style={tdStyle}>{alert.deviceId}</td>
                  <td style={tdStyle}>{alert.type}</td>
                  <td style={tdStyle}>{alert.detail}</td>
                  <td style={tdStyle}>{formatToCST(alert.timestamp)}</td>
                </tr>
              ))}
              {alerts.length === 0 && (
                <tr>
                  <td colSpan="4" style={{ padding: "1rem", textAlign: "center", color: "#888" }}>
                    ✅ No alerts detected — your wish is granted!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const thStyle = {
  padding: "10px",
  borderBottom: "1px solid #ccc",
};

const tdStyle = {
  padding: "8px",
  borderBottom: "1px solid #eee",
};

export default Alerts;
